import { ProductDto } from 'src/store/products/product';

export const PRODUCT_COLUMN_WIDTH_KEY = 'product_column_width';

export const productListColumnWidths: {
  [key in keyof Partial<ProductDto>]: string;
} = {
  runNo: '160px',
  runSystemName: '240px',
  runDate: '210px',
  runText: '120px',
  lotText: '120px',
  gradeName: '260px',
  segmentName: '260px',
  productTypeName: '260px',
  lotNo: '160px',
  lotDate: '210px',
  norlabNo: '160px',
  productStatusName: '200px',
  specificationNo: '200px',
  specificationName: '300px',
  mixtureNo: '160px',
  mixtures: '220px',
  description: '300px'
};
